module.exports = __webpack_public_path__ + "static/media/August_2026_5.ce700314.webp";